const DB_NAME = 'coates_cc_store';
const DB_VERSION = 1;
const STORE_NAME = 'cc';

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export async function idbSet(key: string, value: string): Promise<void> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const iDbTransaction = db.transaction(STORE_NAME, 'readwrite');
    const store = iDbTransaction.objectStore(STORE_NAME);

    store.put(value, key);

    iDbTransaction.oncomplete = () => {
      db.close();
      resolve();
    };
    iDbTransaction.onerror = () => reject(iDbTransaction.error);
  });
}

export async function idbGet(key: string): Promise<string | null> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const iDbTransaction = db.transaction(STORE_NAME, 'readonly');
    const store = iDbTransaction.objectStore(STORE_NAME);
    const request = store.get(key);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      db.close();
      resolve(request.result ?? null);
    };
  });
}

export async function idbRemove(key: string): Promise<void> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const iDbTransaction = db.transaction(STORE_NAME, 'readwrite');
    const store = iDbTransaction.objectStore(STORE_NAME);

    store.delete(key);

    iDbTransaction.oncomplete = () => {
      db.close();
      resolve();
    };
    iDbTransaction.onerror = () => reject(iDbTransaction.error);
  });
}
